<template>
  <v-container fluid>
    <!-- Tabella -->
    <v-data-table
      v-if="data_table === true"
      :headers="headers"
      fixed-header
      :items="cassoni"
      :items-per-page="10"
      item-key="id_macchina"
      calculate-widths
      class="elevation-1 mt-5"
      height="60vh"
    >
      <!-- Intestazione tabella -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Cassoni
            <v-icon color="white"> mdi-truck-trailer </v-icon>
          </v-toolbar-title>
          <!-- Aggiungi cassone -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="nuovoCassone()"
                class="ml-auto mr-n15"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuovo Cassone</span>
          </v-tooltip>
          <!-- Visualizza filtri -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                v-bind="attrs"
                v-on="on"
                small
                @click="filters == true ? (filters = false) : (filters = true)"
              >
                <v-icon color="purple"> mdi-filter </v-icon>
              </v-btn>
            </template>
            <span v-if="filters == false">Visualizza Filtri</span>
            <span v-else>Nascondi Filtri</span>
          </v-tooltip>
          <!-- <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                v-bind="attrs"
                v-on="on"
                small
                @click="dialog_caratteristiche_rifiuto = true"
              >
                <v-icon color="purple"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Caratteristiche rifiuto</span>
          </v-tooltip> -->
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="goBack()"
                class="ml-15"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Vai alla Dashboard</span>
          </v-tooltip>
        </v-toolbar>
        <!-- Row Filtri -->
        <v-row justify="center" v-if="filters === true" class="ma-1">
          <v-col cols="3">
            <v-text-field
              @change="filtra()"
              v-model="matricola_filter"
              label="Matricola"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              @change="filtra()"
              label="Tipo"
              v-model="tipo_veicolo_filter"
              dense
              hide-details
              :items="items_tipo_veicolo"
              item-text="des"
              item-value="id_tabella"
            />
          </v-col>
          <v-col cols="3">
            <v-autocomplete
              @change="filtra()"
              label="Tipo rifiuto"
              v-model="tipo_rifiuto_filter"
              dense
              hide-details
              :items="items_tipo_rifiuto"
              item-text="des"
              item-value="id_tabella"
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              type="number"
              @change="filtra()"
              v-model="volume_filter"
              label="Volume"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              type="number"
              @change="filtra()"
              v-model="massa_filter"
              label="Massa"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              type="number"
              @change="filtra()"
              v-model="massa_pieno_carico_filter"
              label="Massa Trasportabile"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              type="number"
              @change="filtra()"
              v-model="lunghezza_filter"
              label="Lunghezza"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              type="number"
              @change="filtra()"
              v-model="larghezza_filter"
              label="Larghezza"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="3">
            <v-text-field
              type="number"
              @change="filtra()"
              v-model="altezza_filter"
              label="Altezza"
              dense
              hide-details
            />
          </v-col>
          <v-col cols="1">
            <!-- Reset filtri -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mt-5"
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="resetFiltri()"
                >
                  <v-icon color="error"> mdi-filter-off </v-icon>
                </v-btn>
              </template>
              <span>Resetta Filtri</span>
            </v-tooltip>
          </v-col>
          <v-col cols="3">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    filtra();
                    aggiornaAutocomplete();
                  "
                  class="mt-4 success"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Filtra</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>
      <!-- Pulsante edit -->
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              @click="
                selectItem(item);
                data_table = false;
              "
            >
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Dettagli</span>
        </v-tooltip>
      </template>
      <!-- Tipo Rifiuto-->
      <template v-slot:[`item.id_tipo_materiale`]="{ item }">
        {{
          items_tipo_rifiuto.filter(
            (t) => t.id_tabella === item.id_tipo_materiale
          ).length > 0
            ? `${
                items_tipo_rifiuto.filter(
                  (t) => t.id_tabella === item.id_tipo_materiale
                )[0].des
              } `
            : "N/D"
        }}
      </template>
      <!-- Tipo Veicolo -->
      <template v-slot:[`item.id_tipo`]="{ item }">
        {{
          items_tipo_veicolo.filter((v) => v.id_tabella == item.id_tipo)
            .length > 0
            ? `${
                items_tipo_veicolo.filter(
                  (v) => v.id_tabella == item.id_tipo
                )[0].des
              } `
            : "N/D"
        }}
      </template>
      <!-- unita di misura volume -->
      <template v-slot:[`item.um_volume`]="{ item }">
        {{
          items_um_volume.filter((t) => t.id_tabella == item.um_volume).length >
          0
            ? items_um_volume.filter((t) => t.id_tabella == item.um_volume)[0]
                .des
            : "N/D"
        }}
      </template>
      <!-- Motrici Associati -->
      <template v-slot:[`item.associazioni_macchina`]="{ item }">
        <v-btn @click="apriDialogAssociaMotrici(item)" small>
          <v-icon
            :color="item.associazioni_macchina != null ? 'success' : 'error'"
            >mdi-truck</v-icon
          >
        </v-btn>
      </template>
      <!-- Pulsante rimuovi -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              @click="
                selectItem(item);
                delete_dialog = true;
              "
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Create/Edit template -->
    <template v-if="data_table === false">
      <v-card min-height="50vh" class="mt-5">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Cassoni
            <v-icon color="white"> mdi-truck-trailer </v-icon>
          </v-toolbar-title>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto"
                @click="salvaCassone()"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto"
                @click="data_table = true"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <!-- Input -->
          <v-row justify="center" class="ma-1">
            <v-col cols="2">
              <v-text-field
                v-model="selected_item.matricola"
                label="Matricola"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="selected_item.id_tipo"
                dense
                hide-details
                :items="items_tipo_veicolo"
                item-text="des"
                item-value="id_tabella"
              >
                <template #label>
                  <span>Tipo veicolo<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="aggiornaAutocomplete"
                      tipo="EG_TIPO_VEICOLO"
                      nome="Tipo"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1 && id_tabella!=33570"
                      :dati="[{ des: '' },
                              { cod: '' },
                              { val_txt: 'RISORSE_LOGISTIC' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                v-model="selected_item.id_tipo_materiale"
                dense
                hide-details
                :items="items_tipo_rifiuto"
                item-text="des"
                item-value="id_tabella"
              >
                <template #label>
                  <span>Tipo rifiuto<strong>* </strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="aggiornaAutocomplete"
                      tipo="EG_TIPO_RIFIUTO"
                      nome="Tipo"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="1">
              <v-text-field
                type="number"
                v-model.number="selected_item.volume"
                label="Volume"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-autocomplete
                label="UM"
                v-model.number="selected_item.um_volume"
                dense
                hide-details
                :items="items_um_volume"
                item-text="des"
                item-value="id_tabella"
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="number"
                v-model.number="selected_item.massa"
                label="Massa(kg)"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="number"
                v-model.number="selected_item.massa_pieno_carico"
                label="Massa Trasportabile(kg)"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="number"
                v-model.number="selected_item.lunghezza"
                label="Lunghezza(m)"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="number"
                v-model.number="selected_item.larghezza"
                label="Larghezza(m)"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="2">
              <v-text-field
                type="number"
                v-model.number="selected_item.altezza"
                label="Altezza(m)"
                dense
                hide-details
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="selected_item.note"
                label="Note"
                dense
                hide-details
                class="mt-5"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </template>

    <!-- Dialog Associa motrici -->
    <v-dialog persistent v-model="dialog_associa_motrici" max-width="500">
      <v-card min-height="30vh">
        <v-data-table
          :headers="headers_motrici"
          :items="motrici"
          item-key="id_macchina"
        >
          <template v-slot:top>
            <v-toolbar color="indigo" dense class="rounded rounded-b-0">
              <v-toolbar-title class="white--text"> Motrici </v-toolbar-title>
              <v-spacer />
              <!-- Conferma eliminazione -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="ml-auto mr-5"
                    @click="associaMotrici()"
                    v-bind="attrs"
                    v-on="on"
                    small
                  >
                    <v-icon color="success"> mdi-floppy </v-icon>
                  </v-btn>
                </template>
                <span>Conferma</span>
              </v-tooltip>
              <v-spacer />
              <!-- Annulla eliminazione -->
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    @click="dialog_associa_motrici = false"
                  >
                    <v-icon color="error">mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Annulla</span>
              </v-tooltip>
            </v-toolbar>
          </template>
          <template v-slot:[`item.id_macchina`]="{ item }">
            <v-checkbox
              :value="item.id_macchina"
              v-model="motrici_associate"
              dense
              hide-details
            />
          </template>
          <template v-slot:[`item.ragno`]="{ item }">
            <v-icon v-if="item.ragno == 1" small color="success"
              >mdi-check</v-icon
            >
            <v-icon v-else small color="error">mdi-close</v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete -->
    <v-dialog persistent v-model="delete_dialog" max-width="700">
      <v-card min-height="30vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Conferma eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                @click="
                  selected_item.validita = 0;
                  salvaCassone();
                "
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="delete_dialog = false"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-card-text class="mt-10">
          <p class="black--text">
            Sei sicuro di voler eliminare il cassone
            {{ selected_item.matricola }}?
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Cassone {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_macchina", default_val: null },
      { nome: "id_macchina_extra", default_val: null },
      { nome: "matricola", default_val: "" },
      { nome: "id_tipo", default_val: 33567 },
      { nome: "id_tipo_materiale", default_val: null },
      { nome: "volume", default_val: null },
      { nome: "um_volume", default_val: null },
      { nome: "massa", default_val: null },
      { nome: "massa_pieno_carico", default_val: null },
      { nome: "lunghezza", default_val: null },
      { nome: "larghezza", default_val: null },
      { nome: "altezza", default_val: null },
      { nome: "note", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}
export default {
  name: "QLCassoni",

  components: {
    Modules: () => import("../../components/TOOLS/Modules"),
    SnackbarQV,
  },

  props: {},

  data() {
    return {
      // Variabili d'appoggio
      counter: 0,
      overlay: false,
      // Cassone selezionato
      selected_item: new Cassone(),
      // Filtri
      altezza_filter: "",
      larghezza_filter: "",
      lunghezza_filter: "",
      matricola_filter: "",
      massa_filter: "",
      massa_pieno_carico_filter: "",
      tipo_rifiuto_filter: "",
      tipo_veicolo_filter: "",
      volume_filter: "",
      // Variabili tabella/crea/modifica/filtri
      data_table: true,
      delete_dialog: false,
      dialog_associa_motrici: false,
      dialog_caratteristiche_rifiuto: false,
      filters: false,
      // Array
      items_tipo_rifiuto: [],
      items_tipo_veicolo: [],
      items_um_volume: [],
      // arr_temp: [],
      motrici: [],
      motrici_associate: [],
      // cassoni visibili
      cassoni: [],
      tot_cassoni: [],
      // Headers Tabella
      headers: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
        },
        {
          text: "Matricola",
          value: "matricola",
          filterable: false,
          sortable: false,
        },
        {
          text: "Tipo Veicolo",
          value: "id_tipo",
          filterable: false,
          sortable: false,
        },
        {
          text: "Tipo Rifiuto",
          value: "id_tipo_materiale",
          filterable: false,
          sortable: false,
        },
        {
          text: "Volume",
          value: "volume",
          filterable: false,
          sortable: false,
        },
        {
          text: "UM",
          value: "um_volume",
          filterable: false,
          sortable: false,
        },
        {
          text: "Massa",
          value: "massa",
          filterable: false,
          sortable: false,
        },
        {
          text: "Massa Trasportabile",
          value: "massa_pieno_carico",
          filterable: false,
          sortable: false,
        },
        {
          text: "Associato",
          value: "associazioni_macchina",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
        },
      ],
      headers_motrici: [
        {
          text: "Seleziona",
          value: "id_macchina",
          filterable: false,
          sortable: false,
        },
        {
          text: "Codice",
          value: "codice_interno",
          filterable: false,
          sortable: false,
        },
        {
          text: "Targa",
          value: "targa",
          filterable: false,
          sortable: false,
        },
        {
          text: "Ragno",
          value: "ragno",
          filterable: false,
          sortable: false,
        },
      ],
    };
  },

  computed: {},

  watch: {
    variabile: {
      immediate: true,

      handler() {},
    },
  },

  methods: {
    // test() {
    //   console.log(this.arr_temp);
    // },
    // Cassone selezionato
    selectItem(item) {
      console.log(item);
      this.selected_item = new Cassone(JSON.parse(JSON.stringify(item)));
      // if (this.selected_item.id_tipo_materiale.length > 0) {
      //   const arr_tmp = this.selected_item.id_tipo_materiale;
      //   this.selected_item.id_tipo_materiale = [];
      //   arr_tmp.forEach((t) =>
      //     this.selected_item.id_tipo_materiale.push(parseInt(t))
      //   );
      // }
    },
    associaMotrici() {
      const savemacchinerisorsa = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "savemacchinerisorsa",
          token: localStorage.getItem("user_token"),
          id_risorsa: this.selected_item.id_macchina,
          id_macchine: this.motrici_associate.join(),
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api6", savemacchinerisorsa)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.dialog_associa_motrici = false;
            this.motrici_associate = [];
            this.getMacchine();
            this.$refs.SnackbarQV.print(
              "success",
              "Associazione motrici completata"
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        });
    },
    // Nuovo Cassone
    nuovoCassone() {
      this.data_table = false;
      this.selected_item = new Cassone();
    },
    // prendi i cassoni dal db
    getMacchine() {
      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
          val_txt: "RISORSE_LOGISTIC",
          idmacchina: "macchina.id_macchina",
          filter: "validita=1",
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getlistamacchine).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          this.cassoni = [];
          this.tot_cassoni = [];
          // console.table(res.data);
          res.data.macchine.forEach((e) => {
            if (e.extra.length > 0 && e.id_tipo_get_macchina != 33570) {
              let v = e.extra[0];
              v.associazioni_macchina = e.associazioni_macchina;
              this.tot_cassoni.push(v);
            }
          });
          this.cassoni = Array.from(this.tot_cassoni.reverse());
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    // Aggiungi cassone
    salvaCassone() {
      let request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setmacchina",
          token: localStorage.getItem("user_token"),
          tabella: [
            {
              id_macchina: this.selected_item.id_macchina,
              id_tipo_get_macchina: this.selected_item.id_tipo,
            },
          ],
          extra: [this.selected_item],
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", request).then((res) => {
        this.overlay = false;
        // console.log(res.data);
        if (res.status == 200) {
          this.getMacchine();
          this.$refs.SnackbarQV.print(
            "success",
            "Cassone salvato correttamente."
          );
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
      this.filtra();
      this.data_table = true;
      this.delete_dialog = false;
    },
    aggiornaAutocomplete() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'EG_TIPO_RIFIUTO','EG_TIPO_VEICOLO'",
          filter: `validita = 1 && id_tabella!=33570`,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_tipo_rifiuto = res.data.EG_TIPO_RIFIUTO
              ? res.data.EG_TIPO_RIFIUTO
              : [];
            this.items_tipo_veicolo = res.data.EG_TIPO_VEICOLO
              ? res.data.EG_TIPO_VEICOLO
              : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
      this.items_um_volume = [];
      const getvolumi = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          token: localStorage.getItem("user_token"),
          action: "gettabelle",
          tipo: "UNITA_MISURA",
          filter: "val_txt='V'",
        },
      };
      this.$store
        .dispatch("api", getvolumi)
        .then((res) => {
          if (res.status === 200) {
            console.table(res.data);
            this.items_um_volume = res.data ? res.data : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getMotrici() {
      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
          id_tipo_macchina: 33570,
          filter: "validita=1",
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getlistamacchine).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          this.motrici = [];
          res.data.macchine.forEach((e) => {
            if (e.extra.length > 0) {
              this.motrici.push(e.extra[0]);
            }
          });
          this.motrici = this.motrici.reverse();
          // console.table(this.tot_veicoli);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    async apriDialogAssociaMotrici(item) {
      await this.selectItem(item);
      await this.getMotrici();
      let motrici_associate_temp = [];
      if (item.associazioni_macchina != null) {
        motrici_associate_temp = JSON.parse(item.associazioni_macchina);
        motrici_associate_temp.forEach((m) => {
          this.motrici_associate.push(m.id_macchina);
        });
      } else this.motrici_associate = [];
      this.dialog_associa_motrici = true;
    },
    // Filtri
    filtra() {
      /* Preparo un array temporaneo in cui
       * collezionare i cassoni filtrati */
      let cassoni_tmp = [];
      this.tot_cassoni.forEach((v) => {
        cassoni_tmp.push(new Cassone(v));
      });

      //Filtro per tipo veicolo
      if (
        this.tipo_veicolo_filter != "" &&
        typeof this.tipo_veicolo_filter !== "object"
      ) {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (elem.id_tipo == this.tipo_veicolo_filter) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }

      //Filtro per tipo rifiuto
      if (
        this.tipo_rifiuto_filter != "" &&
        typeof this.tipo_rifiuto_filter !== "object"
      ) {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          // elem.id_tipo_materiale.forEach((t) => {
          //   if (t == this.tipo_rifiuto_filter) {
          //     res.push(new Cassone(elem));
          //   }
          // });
          if (elem.id_tipo_materiale == this.tipo_rifiuto_filter) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }
      //Filtro per matricola
      if (this.matricola_filter != "") {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (
            elem.matricola
              .toUpperCase()
              .includes(this.matricola_filter.toUpperCase())
          ) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }
      // Filtro per volume
      if (this.volume_filter != null && this.volume_filter != "") {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (JSON.stringify(elem.volume).includes(this.volume_filter)) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }
      //Filtro per massa
      if (this.massa_filter != null && this.massa_filter != "") {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (JSON.stringify(elem.massa).includes(this.massa_filter)) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }
      //Filtro per massa trasportabile
      if (
        this.massa_pieno_carico_filter != "" &&
        this.massa_pieno_carico_filter != null
      ) {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (
            JSON.stringify(elem.massa_pieno_carico).includes(
              this.massa_pieno_carico_filter
            )
          ) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }
      //Filtro per lunghezza
      if (this.lunghezza_filter != "" && this.lunghezza_filter != null) {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (JSON.stringify(elem.lunghezza).includes(this.lunghezza_filter)) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }
      //Filtro per larghezza
      if (this.larghezza_filter != "" && this.larghezza_filter != null) {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (JSON.stringify(elem.larghezza).includes(this.larghezza_filter)) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }
      //Filtro per altezza
      if (this.altezza_filter != "" && this.altezza_filter != null) {
        let res = [];
        cassoni_tmp.forEach((elem) => {
          if (JSON.stringify(elem.altezza).includes(this.altezza_filter)) {
            res.push(new Cassone(elem));
          }
        });
        cassoni_tmp = [];
        res.forEach((e) => {
          cassoni_tmp.push(new Cassone(e));
        });
      }

      // Ricostruisco i cassoni visualizzati in base ai filtri aggiunti.
      this.cassoni = [];
      this.cassoni = Array.from(cassoni_tmp);
    },
    resetFiltri() {
      this.tipo_rifiuto_filter = "";
      this.matricola_filter = "";
      this.volume_filter = "";
      this.massa_filter = "";
      this.massa_pieno_carico_filter = "";
      this.lunghezza_filter = "";
      this.larghezza_filter = "";
      this.altezza_filter = "";
      this.filtra();
    },
    goBack() {
      this.$router.push("/home/quicklogistic");
    },
  },

  created() {
    this.aggiornaAutocomplete();
    this.getMacchine();
  },

  mounted() {},
};
</script>

<style scoped>
</style>